import { cx } from '@/shared/ui/cx';

export type SpinnerProps = {
  size?: number;
  className?: string;
  /** Announced to screen readers while work is in flight. */
  label?: string;
};

/**
 * A spinner reports live state, so it keeps animating under
 * `prefers-reduced-motion` — a frozen spinner reads as a hung app. That is what
 * `data-motion="essential"` opts out of in base.css.
 */
export function Spinner({ size = 16, className, label }: SpinnerProps) {
  return (
    <span
      className={cx('spinner', className)}
      style={{ width: size, height: size }}
      data-motion="essential"
      role={label ? 'status' : undefined}
      aria-hidden={label ? undefined : true}
    >
      {label ? <span className="sr-only">{label}</span> : null}
    </span>
  );
}
